import * as React from 'react';
import styled from 'styled-components';

import { ListView } from '@longline/aqua-ui/controls/ListView';
import { Message } from '@longline/aqua-ui/containers/Message';
import { SecondaryButton } from '@longline/aqua-ui/controls/SecondaryButton';
import { SVG } from '@longline/aqua-ui/svg';

import { IDriverset } from '../../../api/models';

interface IProps {
  driversets: IDriverset[];
  onAdd?: () => void;
  onSelect: (driverset: IDriverset) => void;
}

const DriversetList = (props: IProps) =>
  <div style={{ height: '100%', display: "flex", flexDirection: 'column' }}>
    <div style={{ position: 'relative', height: '100%' }}>
    <ListView
      dark
      data={props.driversets}
      onClick={i => props.onSelect(i)}
      singular="driver set"
      plural="driver sets"
      shadow
      hover
      total
      rowHeight={56}
      noData={<Message.NoData margin>There are no driver sets yet.</Message.NoData>}
    >
      <ListView.Column active width={1} name="Name" sort="name" defaultSort>{(item: IDriverset) => item.name}</ListView.Column>
      <ListView.Column active width="100px" align="right" name="Days">{(item: IDriverset) => item.dates.length}</ListView.Column>
    </ListView>
    {props.onAdd && <ButtonHolder>
      <SecondaryButton positive title="Add driver set" icon={SVG.Icons.Plus} onClick={props.onAdd}/>
    </ButtonHolder>}
    </div>
  </div>

const ButtonHolder = styled.div`
  position: absolute;
  z-index: 100;
  right: 16px;
  bottom: 16px;
`

export { DriversetList }
